/* @ngInject */
function updateTitle($rootScope, $timeout, $state, SETTINGS) {
  return function link(scope, element) {
    /* eslint angular/on-watch: 0 */
    const defaultTitle = 'Login';

    $rootScope.$on('$stateChangeSuccess', (event, toState) => {
      const title = (toState.data && toState.data.pageTitle) || defaultTitle;

      $timeout(() => element.text(`${title} | ${SETTINGS.SITE_NAME} Login`), 0, false);
    });

    $rootScope.$on('UpdateTitle', (event, data) => {
      const pageTitle = $state.current.data && $state.current.data.pageTitle;
      const title = data || defaultTitle;
      const subtitle = (pageTitle && ` – ${pageTitle} `) || ' ';
      $timeout(() => element.text(`${title}${subtitle}| ${SETTINGS.SITE_NAME} Login`), 0, false);
    });
  };
}

export default updateTitle;



// WEBPACK FOOTER //
// ./client/components/update-title/update-title.directive.js